let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eUrwV")).then(() => parcelRequire('9zs6n'));